import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from './common/toasts/app-header/app-header.component';
import { ToastsContainerComponent } from './common/toasts/toasts-container.component';

@Component({
  selector: 'co-app',
  template: `
    <man-app-header></man-app-header>
    <router-outlet></router-outlet>
    <co-toasts-container></co-toasts-container>
  `,
  host: { class: 'app' },
  standalone: true,
  imports: [
    AppHeaderComponent,
    CommonModule,
    RouterOutlet,
    ToastsContainerComponent
  ]
})
export class AppComponent {}
